module.exports = __webpack_public_path__ + "513ef5fdfbdecaede63ab62d56d6c1e6.svg";